<script>
    import Button, { Label } from '@smui/button';
    import Dialog, { Actions, Content, Title } from '@smui/dialog';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();


    let eventDialog;
    let customErrorMessage;
    let actionText;

    export function open(errorMessage, action) {
        customErrorMessage = errorMessage
        actionText = action
        eventDialog.setOpen(true);
    }

    function onAction() {
        dispatch('action');
    }
</script>

<Dialog bind:this={eventDialog}
    scrimClickAction=""
    escapeKeyAction=""
    aria-labelledby="mandatory-title"
    aria-describedby="mandatory-content">
    <Title id="title" style="color: red; font-weight: bold;">Error!</Title>
    <Content id="content" >
        { customErrorMessage }
    </Content>
    <Actions>
        <Button  on:click={onAction}>
            <Label>{ actionText }</Label>
        </Button>
    </Actions>
</Dialog>
